<script setup lang="ts">
import type { Product } from '~~/server/api/menu/main'

export interface SubmenuCategoryProductsProps {
    products: Product[]
    title: string
    categorySlug: string
}

const props = defineProps<SubmenuCategoryProductsProps>()
</script>
<template>
  <section
    class="submeny-category-products-group rounded-3 px-4 p-md-3 mb-4 mb-md-3"
  >
    <h2 class="submenu-category-subtitle fs-xsmall mb-2">
      {{ props.title }}
    </h2>
    <SubmenuCategoryProducts
      :products="props.products"
      :category-slug="props.categorySlug"
    />
  </section>
</template>
<style lang="scss" scoped>
@import './SubmenuCategoryProductsGroup.scss';
</style>
